import useAuth from "hooks/useAuth";
import React from "react";

const SpinnerLoading = ({ spinnerRef }) => {
  const { loading } = useAuth();
  if (!loading) return;
  return (
    <div
      ref={spinnerRef}
      className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div className="animate-spin rounded-full h-20 w-20 border-b-[3px] border-gray-300"></div>
    </div>
  );
};

export default SpinnerLoading;
